module.exports = __webpack_public_path__ + "img/swiper3.a28c377e.png";